import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'copy-clipboard',
})

export default class CopyClipboard extends Vue {
    @Prop()
    public value: any;

    public isClickedToCopy: boolean = false;

    public isCopied: boolean = false;

    public async copyToClipboard() {
      if (this.isCopied) {
        return;
      }
      this.isClickedToCopy = true;
      try {
          await navigator.clipboard.writeText(this.value);
          this.isCopied = true;
          setTimeout(() => {
            this.isClickedToCopy = false;
            this.isCopied = false;
          }, 1500);
        } catch ($e) {
          this.isCopied = false;
          setTimeout(() => {
            this.isClickedToCopy = false;
          }, 1500);
        }
    }
}
